import { render, staticRenderFns } from "./jjlbxiangqing.vue?vue&type=template&id=18abc775&scoped=true"
import script from "./jjlbxiangqing.vue?vue&type=script&lang=js"
export * from "./jjlbxiangqing.vue?vue&type=script&lang=js"
import style0 from "./jjlbxiangqing.vue?vue&type=style&index=0&id=18abc775&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18abc775",
  null
  
)

export default component.exports